'use client';

import { App } from './src/app/App';
import type { ProductConfig } from './src/domain/types';

/** Client boundary that keeps the portable configurator independent from the Next.js host. */
export function ConfiguratorPage({
  products,
  source = 'local',
}: {
  products?: ProductConfig[];
  source?: 'backend' | 'local';
}) {
  return <App productCatalogue={products} productSource={source} />;
}
